mcWeb.checkoutConfirmation = new function() {

	//Is used for all the new instances 
	this.instance = new function () { };

	this.checkoutConfirmationObj = function (id, json, jsonSetting) {
		var $ = jQuery;

		var self = this;
		self.id = "#" + id;
		self.service = new WebApiService("Cart");

		//View Model
		self.vm = new function () {
			var view = this;
			view.referenceNo = ko.observable();
		}; /*END viewModel*/

		self.load = function (obj, setting) {
			if (obj == null)
				return;

			self.vm.referenceNo(obj.ReferenceNo);
		};

		//Bind viewModel
		ko.applyBindings(self.vm, document.getElementById(id));
		self.load(json, jsonSetting);
	};
};